import Input from './Input';

const TelInput = (props) => {
    return <Input type="tel" {...props} />;
};

export default TelInput;
